// Money input that shows thousands separators while typing; `value`/`onChange` carry a plain digit string.
export const fmtThousands = (v) => {
  const digits = String(v ?? "").replace(/[^\d]/g, "");
  return digits ? Number(digits).toLocaleString("en-KE") : "";
};

export const KesInput = ({ value, onChange, className = "", prefix = "KES", testid, placeholder = "e.g. 2,500,000", required, autoFocus }) => (
  <div className="relative">
    <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-neutral-500">{prefix}</span>
    <input type="text" inputMode="numeric" autoComplete="off" required={required} autoFocus={autoFocus}
      value={fmtThousands(value)} placeholder={placeholder}
      onChange={(e) => onChange(e.target.value.replace(/[^\d]/g, ""))}
      className={`${className} pl-14`} data-testid={testid} />
  </div>
);
